import { combineReducers } from 'redux';

import charts from 'reducers/mapview/chartsForExport';
import error from 'reducers/mapview/error';
import expandDrawPanel from 'reducers/mapview/expandDrawPanel';
import histogramResults from 'reducers/mapview/histogramResults';
import layers from 'reducers/mapview/layers';
import layerInfo from 'reducers/mapview/layerInfo';
import loaderActive from 'reducers/mapview/loaderActive';
import reportIsAvailable from 'reducers/mapview/reportIsAvailable';
import showAnalysis from 'reducers/mapview/showAnalysis';
import precalculatedCSVData from 'reducers/mapview/precalculatedCSVData';
import precalculatedShape from 'reducers/mapview/precalculatedShape';
import snapshot from 'reducers/mapview/snapshot';
import totalArea from 'reducers/mapview/totalAreaForCSV';
import userDrawnPolygon from 'reducers/mapview/userDrawnPolygon';
import showBasemapSelector from 'reducers/mapview/showBasemapSelector';
import visibleLayers from 'reducers/mapview/visibleLayers';
import yearsSelected from 'reducers/mapview/yearsSelected';

const mapview = combineReducers({
  charts,
  error,
  expandDrawPanel,
  histogramResults,
  layers,
  layerInfo,
  loaderActive,
  precalculatedShape,
  reportIsAvailable,
  showAnalysis,
  precalculatedCSVData,
  showBasemapSelector,
  snapshot,
  totalArea,
  userDrawnPolygon,
  visibleLayers,
  yearsSelected
});

export default mapview;
